export const TRUSTED_BADGE_VARIANT = {
	DARK: 'dark',
	LIGHT: 'light',
} as const;

export type TrustedBadgeVariant = (typeof TRUSTED_BADGE_VARIANT)[keyof typeof TRUSTED_BADGE_VARIANT];
